import React, { Fragment, useContext } from 'react';
import ContenedorOpcionesCuenta from '../barraprincipal/ContenedorOpcionesCuenta';
import VerTarea from '../tareas/VerTarea';
import DetallesProyecto from '../proyectos/DetallesProyecto';
import ListadoTareas from '../tareas/ListadoTareas';

import proyectoContext from '../../context/proyectos/proyectoContext';
import tareaContext from '../../context/tareas/tareaContext';
import barraprincipalContext from '../../context/barraprincipal/barraprincipalContext';

const ContenedorPrincipal = () => {

    // Extraer si una vista fue seleccionada
    const proyectosContext = useContext(proyectoContext);
    const { verdetalles } = proyectosContext;

    // Obtener la funcion del context de tarea
    const tareasContext = useContext(tareaContext);
    const { vertarea } = tareasContext;

    // Extraer funciones del context
    const barrapplContext = useContext(barraprincipalContext);
    const { vistamenu } = barrapplContext;

    return (
        <Fragment>
            {vistamenu ? (
                <ContenedorOpcionesCuenta />
            ) : (
                vertarea ? (
                    <VerTarea />
                ) : (
                    verdetalles ? (
                        <DetallesProyecto /> 
                    ) : (
                        <ListadoTareas />
                    )
                )
            )
            }
        </Fragment>
     );
}
 
export default ContenedorPrincipal;